document.addEventListener('DOMContentLoaded', () => {
  console.log('Let\'s script');
});
